module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAA20lEQVQ4T32SgQ0BQRBFnwroABXQATqgAnRwHaADHaACSqADOlACHciTHVmbu9tkM8n8PzN//m6H5tNL0KuO0qlJDoADME3YFVgDz5xbV3gHvFUi7oE+MGsrHANOCJnBVa4KbPg95UTBbSYzeDYzb2wsdL9hsbv7rdoK5StrnpFUcSnll1J19Ay8C1e7wCJ3Ni90hw1wSvuE/TYTW6a4y81Rf5jy917ZrjYIk44x0UQkWz7Tr/k0Cn3kEWDUnEeKNvFNxYx+CrEqCiOpg5OGkbek6tu87su1Sf1hH2YyLQ/+wE7jAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/me.png
// module id = BeWI
// module chunks = 1